import { gql } from "@apollo/client";

export const GET_LOCK_NOTES_BY_CUSTOMER_ID = gql`
query getLockNotesByCustomerId($customerid: String!) {
  getLockNotesByCustomerId(customerid: $customerid) {
    status
    error
    locknotes {
      locknoteid
      reason
      islock
      datetimecreated
      user {
        userid
        name
      }
    }
  }
}`;

export const GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID = gql`
query getLastLockNoteByCustomerId($customerid: String!) {
  getLastLockNoteByCustomerId(customerid: $customerid) {
    status
    error
    locknote {
      locknoteid
      reason
      islock
    }
  }
}`;